import { PropsWithChildren, forwardRef, useContext } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Loading from 'modules/layout/components/Page/Loading'
import { PageContext } from 'modules/layout/components/Page/Provider'

import './index.styles.css'

interface Props {
  size?: 'narrow' | 'full' | 'wide'
  withoutPadding?: boolean
}

export default forwardRef<HTMLDivElement, PropsWithChildren<Props>>(function Body(
  { children, withoutPadding, size },
  ref
) {
  const isLoading = useContext(PageContext)
  const paddingStyle = withoutPadding ? 'Body_withoutPadding' : undefined
  let sizeStyle: string

  switch (size) {
    case 'narrow':
      sizeStyle = 'Body_narrow'
      break
    case 'full':
      sizeStyle = 'Body_full'
      break
    default:
      sizeStyle = 'Body_wide'
  }

  return (
    <Box className={`${sizeStyle} ${paddingStyle ?? ''}`.trim()} ref={ref}>
      {isLoading ? <Loading /> : children}
    </Box>
  )
})
